import { AssembleCanvas } from "@/components/AssembleCanvas";
import { buildGlobeNet, GLOBE_TIMING } from "@/lib/brainScene";
import { useDelayedReveal } from "@/lib/useDelayedReveal";

export const Hero = () => {
  const on = useDelayedReveal(2500);
  const fx = `scan-text ${on ? "is-on" : ""}`;
  return (
    <section id="top" className="hero-full relative w-full overflow-hidden" data-testid="hero-section">
      <AssembleCanvas dim={on} build={buildGlobeNet} timing={GLOBE_TIMING} scale={0.3} testId="hero-globe-canvas" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(ellipse 55% 45% at center, rgba(5,5,5,0.6), rgba(5,5,5,0) 70%)", opacity: on ? 1 : 0, transition: "opacity 1.4s ease" }}
      />
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6 pointer-events-none" data-testid="hero-text" data-visible={on}>
        <h1
          className={`${fx} font-extrabold tracking-[-0.045em] leading-[0.95] text-5xl sm:text-7xl lg:text-8xl xl:text-[7.5rem] max-w-6xl`}
          data-testid="hero-title"
        >
          Il futuro del talento.
        </h1>
        <p className={`${fx} mt-8 max-w-xl text-base sm:text-lg text-titanium leading-relaxed`} style={{ transitionDelay: on ? "250ms" : "0ms" }} data-testid="hero-subtitle">
          Prodigy restituisce alle Persone il loro valore.
        </p>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-3 pointer-events-none">
        <span className="text-[10px] tracking-[0.35em] uppercase text-titanium">Scorri</span>
        <span className="h-8 w-[18px] rounded-full border border-[#2a2d33] flex justify-center pt-1.5">
          <span className="anim-scroll-dot h-1.5 w-1 rounded-full bg-[#00e5ff]" />
        </span>
      </div>
    </section>
  );
};
